/* SOCIALLY RECLUSIVE — theme.js (vanilla, no framework) */
(function () {
  "use strict";

  function money(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  async function refreshCartCount() {
    try {
      const res = await fetch("/cart.js", { headers: { "Accept": "application/json" } });
      const cart = await res.json();
      document.querySelectorAll("[data-cart-count]").forEach(function (el) {
        el.textContent = cart.item_count;
      });
    } catch (e) { /* quiet */ }
  }

  /* ---- Variant selection on product page ---- */
  function initProductForm() {
    const form = document.querySelector("[data-product-form]");
    if (!form) return;

    let variants = [];
    try { variants = JSON.parse(form.getAttribute("data-variants") || "[]"); } catch (e) {}

    const idInput = form.querySelector("[data-variant-id]");
    const priceEl = document.querySelector("[data-product-price]");
    const buyBtn = form.querySelector("[data-buy]");
    const soldEl = document.querySelector("[data-sold]");

    function selectedOptions() {
      const opts = [];
      form.querySelectorAll("[data-option-index]").forEach(function (group) {
        const checked = group.querySelector("input:checked");
        if (checked) opts[parseInt(group.getAttribute("data-option-index"), 10)] = checked.value;
      });
      return opts;
    }

    function matchVariant() {
      const sel = selectedOptions();
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      });
    }

    function update() {
      const v = matchVariant();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      const available = v.available;
      if (buyBtn) { buyBtn.disabled = !available; buyBtn.style.display = available ? "" : "none"; }
      if (soldEl) soldEl.style.display = available ? "none" : "";
    }

    form.querySelectorAll("[data-option-index] input").forEach(function (input) {
      input.addEventListener("change", update);
    });
    update();

    form.addEventListener("submit", async function (e) {
      e.preventDefault();
      const v = matchVariant();
      if (!v || !v.available) return;
      buyBtn.disabled = true;
      const original = buyBtn.textContent;
      buyBtn.textContent = "ADDING…";
      try {
        var addRes = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: v.id, quantity: 1, sections: "cart-drawer" }),
        });
        var addData = await addRes.json();
        swapDrawer(addData);
        await refreshCartCount();
        buyBtn.textContent = "ADDED ✓";
        if (window.__srCartOpen) window.__srCartOpen();
        setTimeout(function () { buyBtn.textContent = original; buyBtn.disabled = false; }, 1400);
      } catch (err) {
        buyBtn.textContent = original; buyBtn.disabled = false;
      }
    });
  }

  /* ---- Cart page quantity changes ---- */
  function initCart() {
    document.querySelectorAll("[data-cart-qty]").forEach(function (input) {
      input.addEventListener("change", async function () {
        const key = input.getAttribute("data-key");
        const qty = Math.max(0, parseInt(input.value, 10) || 0);
        await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: key, quantity: qty }),
        });
        window.location.reload();
      });
    });
  }

  /* ---- Header: search panel + mobile drawer ---- */
  function initHeader() {
    var searchToggle = document.querySelector("[data-search-toggle]");
    var searchPanel = document.querySelector("[data-search-panel]");
    if (searchToggle && searchPanel) {
      searchToggle.addEventListener("click", function () {
        var closed = searchPanel.hasAttribute("hidden");
        if (closed) {
          searchPanel.removeAttribute("hidden");
          searchToggle.setAttribute("aria-expanded", "true");
          var input = searchPanel.querySelector("input[type=search]");
          if (input) input.focus();
        } else {
          searchPanel.setAttribute("hidden", "");
          searchToggle.setAttribute("aria-expanded", "false");
        }
      });
    }

    var menuOpen = document.querySelector("[data-menu-open]");
    var menuClose = document.querySelector("[data-menu-close]");
    var menuPanel = document.querySelector("[data-menu-panel]");
    function setMenu(open) {
      if (!menuPanel) return;
      if (open) {
        menuPanel.removeAttribute("hidden");
        document.body.style.overflow = "hidden";
        if (menuOpen) menuOpen.setAttribute("aria-expanded", "true");
      } else {
        menuPanel.setAttribute("hidden", "");
        document.body.style.overflow = "";
        if (menuOpen) menuOpen.setAttribute("aria-expanded", "false");
      }
    }
    if (menuOpen) menuOpen.addEventListener("click", function () { setMenu(true); });
    if (menuClose) menuClose.addEventListener("click", function () { setMenu(false); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") setMenu(false); });
  }

  /* ---- Cart drawer ---- */
  function swapDrawer(data) {
    if (!data || !data.sections || !data.sections["cart-drawer"]) return;
    var doc = new DOMParser().parseFromString(data.sections["cart-drawer"], "text/html");
    var fresh = doc.querySelector("#sr-cart-inner");
    var cur = document.querySelector("#sr-cart-inner");
    if (fresh && cur) cur.innerHTML = fresh.innerHTML;
  }

  async function changeItem(key, qty) {
    try {
      var res = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: key, quantity: qty, sections: "cart-drawer" }),
      });
      var data = await res.json();
      swapDrawer(data);
      await refreshCartCount();
    } catch (e) { /* quiet */ }
  }

  function initCartDrawer() {
    var drawer = document.querySelector("[data-cart-drawer]");
    if (!drawer) return;

    function open() { drawer.removeAttribute("hidden"); document.body.style.overflow = "hidden"; }
    function close() { drawer.setAttribute("hidden", ""); document.body.style.overflow = ""; }
    window.__srCartOpen = open;

    document.querySelectorAll("[data-cart-open]").forEach(function (el) {
      el.addEventListener("click", function (e) { e.preventDefault(); open(); });
    });

    drawer.addEventListener("click", function (e) {
      if (e.target.closest("[data-cart-close]")) { close(); return; }

      if (e.target.closest("[data-disc-apply]")) {
        var input = drawer.querySelector("#sr-disc");
        var code = input && input.value ? input.value.trim() : "";
        if (code) window.location.href = "/discount/" + encodeURIComponent(code) + "?redirect=/checkout";
        return;
      }

      var line = e.target.closest("[data-key]");
      if (!line) return;
      var key = line.getAttribute("data-key");
      var valEl = line.querySelector(".sr-stepper__val");
      var cur = parseInt(valEl ? valEl.textContent : "1", 10) || 1;
      if (e.target.closest("[data-qty-inc]")) changeItem(key, cur + 1);
      else if (e.target.closest("[data-qty-dec]")) changeItem(key, Math.max(0, cur - 1));
      else if (e.target.closest("[data-remove]")) changeItem(key, 0);
    });

    document.addEventListener("keydown", function (e) { if (e.key === "Escape") close(); });
  }

  /* ---- Product gallery carousel ---- */
  function initGallery() {
    document.querySelectorAll("[data-gallery]").forEach(function (g) {
      var track = g.querySelector("[data-gallery-track]");
      var dots = g.querySelectorAll("[data-gallery-dot]");
      if (!track || !dots.length) return;
      dots.forEach(function (d) {
        d.addEventListener("click", function () {
          var i = parseInt(d.getAttribute("data-gallery-dot"), 10);
          var slide = track.children[i];
          if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: "smooth" });
        });
      });
      var ticking = false;
      track.addEventListener("scroll", function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          var i = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach(function (d, di) { d.classList.toggle("is-active", di === i); });
          ticking = false;
        });
      });
    });
  }


  document.addEventListener("DOMContentLoaded", function () {
    refreshCartCount();
    initProductForm();
    initCart();
    initHeader();
    initCartDrawer();
    initGallery();
  });
})();
